import { ProfilePage } from "@/components/features/profile/ProfilePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/profile/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ProfilePage />;
}
